'use client';

// import { useState } from "react";

export default function UserNavbar({ onToggleSidebar }) {
  // const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>
      <style>{`
        .user-navbar {
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 249, 250, 0.98) 100%);
          border-bottom: 1px solid #e2e8f0;
          padding: 1rem;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
          position: sticky;
          top: 0;
          z-index: 1010;
          height: 80px;
          margin: 11px 5px;
        }

        .navbar-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          padding: 10px;
          margin: auto 10px;
        }

        .navbar-left {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .hamburger-btn {
          display: none;
          background: #3b82fb;
          border: none;
          color: white;
          padding: 0.5rem 0.75rem;
          border-radius: 8px;
          cursor: pointer;
          font-size: 1.25rem;
          transition: all 0.3s ease;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
        }

        .hamburger-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
        }

        .navbar-brand {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin: 0;
        }

        .navbar-right {
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .navbar-link {
          color: #475569;
          text-decoration: none;
          font-weight: 500;
          padding: 0.5rem 1rem;
          border-radius: 8px;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }

        .navbar-link:hover {
          background: #f1f5f9;
          color: #4F46E5;
        }

        .btn-idea {
          // background: linear-gradient(135deg, #4F46E5 0%, #3730A3 100%);
          color: white;
          padding: 0.5rem 1.25rem;
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.3s ease;
          border: none;
          cursor: pointer;
          font-size: 0.95rem;
        }

        .btn-idea:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
        }

        /* Tablet and smaller screens */
        @media (max-width: 1024px) {

          .navbar-container {
            padding: 0;
          }

          .btn-idea {
            padding: 0.4rem 1rem;
            font-size: 0.9rem;
          }
        }

        /* Mobile screens */
        @media (max-width: 768px) {
          .user-navbar {
            margin: 0px;
            height: auto;
          }
          .hamburger-btn {
            display: flex;
          }
          .user-navbar {
            padding: 0.8rem 0.75rem;
          }

          .navbar-brand {
            font-size: 1.25rem;
          }

          .navbar-link {
            padding: 0.5rem;
            font-size: 0.9rem;
          }

          .btn-idea {
            padding: 0.4rem 0.9rem;
            font-size: 0.85rem;
          }

          .navbar-right {
            gap: 0.5rem;
          }
        }

        /* Extra small screens */
        @media (max-width: 480px) {
          .user-navbar {
            padding: 0.7rem;
          }

          .navbar-brand {
            font-size: 1.1rem;
            // display: none;
          }

          .hamburger-btn {
            width: 36px;
            height: 36px;
            font-size: 1.1rem;
          }

          .btn-idea {
            padding: 0.4rem 0.7rem;
            font-size: 0.8rem;
            white-space: nowrap;
          }
        }
      `}</style>

      <nav className="user-navbar">
        <div className="navbar-container">
          <div className="navbar-left">
            <button 
              className="hamburger-btn" 
              onClick={onToggleSidebar}
              title="Toggle sidebar"
            >
              ☰
            </button>
            <h3 className="navbar-brand">Dashboard</h3>
          </div>

          <div className="navbar-right">
            <a href="/user-dashboard" className="btn-idea">
             
            </a>
          </div>
        </div>
      </nav>
    </>
  );
}
